import { render, staticRenderFns } from "./ValidatePassword.vue?vue&type=template&id=789d8b6a&scoped=true&"
import script from "./ValidatePassword.vue?vue&type=script&lang=ts&"
export * from "./ValidatePassword.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatePassword.vue?vue&type=style&index=0&id=789d8b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d8b6a",
  null
  
)

export default component.exports